import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-company-data',
  styleUrls: ['./company-data.component.scss'],
  templateUrl: './company-data.component.html',
})
export class CompanyDataComponent {
  @Input() meterType: string;
  @Input() companyDataFG: FormGroup;
  @Input() isReadOnly: boolean = false;

  constructor() {}
}
